module.exports = __webpack_public_path__ + "img/informazione_ferie2.a3b9afa9.png";